import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  Form,
  Select,
  InputNumber,
  Button,
  Typography,
  Flex,
  Grid,
} from "antd";
import {
  saveCustomerSpecialPrice,
  fetchItems,
  fetchCustomersAndGroups,
} from "../CustomerSpecialPriceThunk";

const { Title } = Typography;
const { useBreakpoint } = Grid;

const CreateCustomerSpecialPriceForm = ({ onCancel, messageApi }) => {
  const dispatch = useDispatch();
  const [form] = Form.useForm();
  const screens = useBreakpoint();

  const { items, customersGroups, loadingSave, isEdit, formData } = useSelector(
    (state) => state.customerSpecialPrice
  );

  // Fetch base data
  useEffect(() => {
    dispatch(fetchItems());
    dispatch(fetchCustomersAndGroups());
  }, [dispatch]);

  // Pre-fill edit form
  useEffect(() => {
    if (isEdit && formData) {

      const acc_id = formData.type === "group"
        ? formData.customer_group_id
        : formData.acc_id;

      form.setFieldsValue({
        item_id: formData.item_id,
        customer_id: `${acc_id}_${formData.type}`,
        price: formData.price,
      });
    } else {
      form.resetFields();
    }
  }, [isEdit, formData, form]);

  const onFinish = (values) => {
    const [account_id, type] = values.customer_id.split("_");

    const payload = {
      id: isEdit && formData ? formData.id : 0,
      item_id: values.item_id,
      price: values.price,
      action: isEdit ? "update" : "create",
      type: type
    };

    if (type === "customer") {
      payload.account_id = account_id;
    }

    if (type === "group") {
      payload.customer_group_id = account_id;
    }
   
    dispatch(saveCustomerSpecialPrice(payload)).then((res) => {
      if (res.meta.requestStatus === "fulfilled") {
        messageApi.success("Special Price saved successfully ✅");
        onCancel();
      } else {
        messageApi.error("Failed to save Special Price ❌");
      }
    });
  };

  const isMobile = !screens.md;

  return (
    <div className="customer-special-price-form">
      <Title level={4} style={{ marginBottom: 24, whiteSpace: "normal" }}>
        {isEdit ? "Edit Customer Special Price" : "Add Customer Special Price"}
      </Title>

      <Form
        form={form}
        layout={isMobile ? "vertical" : "horizontal"}
        onFinish={onFinish}
        style={{ width: "100%", maxWidth: "1400px" }}
        colon={false}
        labelCol={isMobile ? undefined : { span: 8 }}
        wrapperCol={isMobile ? undefined : { span: 16 }}
      >
        {/* Two Column Layout for Inputs */}
        <Flex
          gap={!screens.md || !screens.xl ? 10 : 60}
          justify="center"
          style={{
            flexDirection: !screens.md || !screens.xl ? "column" : "row",
            width: "100%",
            marginBottom: 24,
          }}
        >
          {/* Left Column */}
          <Flex
            vertical
            gap={12}
            style={{ width: !screens.md || !screens.xl ? "100%" : "45%" }}
          >
            <Form.Item
              label="Select Item"
              name="item_id"
              rules={[{ required: true, message: "Item is required" }]}
            >
              <Select placeholder="Select Item" disabled={isEdit}>
                {items.map((item) => (
                  <Select.Option key={item.item_id} value={item.item_id}>
                    {item.item_name}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>

            <Form.Item
              label="Item Price"
              name="price"
              rules={[{ required: true, message: "Price is required" }]}
            >
              <InputNumber
                min={0}
                style={{ width: "100%" }}
                placeholder="Enter Price"
                onWheel={(e) => e.target.blur()}
              />
            </Form.Item>
          </Flex>

          {/* Right Column */}
          <Flex
            vertical
            gap={12}
            style={{ width: !screens.md || !screens.xl ? "100%" : "45%" }}
          >
            <Form.Item
              label="Select Customer / Group"
              name="customer_id"
              rules={[
                { required: true, message: "Customer / Group is required" },
              ]}
            >
              <Select placeholder="Select Customer or Group" disabled={isEdit}>
                {customersGroups.map((item) => (
                  <Select.Option
                    key={`${item.acc_id}-${item.type}`}
                    value={`${item.acc_id}_${item.type}`}
                  >
                    {item.acc_name} ({item.type})
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>
          </Flex>
        </Flex>

        {/* Buttons */}
        <Flex justify="end" gap={16} style={{ marginTop: 16 }}>
          {isEdit && (
            <Button onClick={onCancel} size="large" className="traic-button">
              Cancel
            </Button>
          )}
          <Button
            type="primary"
            htmlType="submit"
            size="large"
            className="traic-button"
            loading={loadingSave}
          >
            Save
          </Button>
        </Flex>
      </Form>
    </div>
  );
};

export default CreateCustomerSpecialPriceForm;
